import React from 'react';

import withLazyLoad from 'utils/withLazyLoad';
import withPid from 'utils/withPid';
import AboutPage, { IAboutPageProps } from '../../components/AboutPage';

const AboutUsConfig: IAboutPageProps = {
    title: 'About US',
    paragraph: [
        `Advertising services; Business organization consultancy; Business appraisals; Market
        analysis; Commercial and industrial management assistance; Business efficiency expert
        services; Marketing services; Sales promotion for others; Compilation of information into
        computer databases.`,
        `Technical support services, namely, installation, administration, and troubleshooting of web
        and database applications; Technical support services, namely, troubleshooting of computer
        software problems; Industrial design; Computer programming; Web site design consultancy;
        Computer systems analysis; Creating and maintaining web sites for others; Updating of
        computer software; Testing, analysis, and evaluation of computer software to assure
        compliance with computer industry standards`
    ]
};

const AboutUS: React.FC = () => {
    return <AboutPage {...AboutUsConfig} />;
};

export default withLazyLoad(withPid('brand')(AboutUS));
